import React from "react";
import i18n from "i18next";
import {Link} from "react-router-dom";

import {swalBadRequest, swalQuestion} from "../Swal";
import {dellIndicators, restoreIndicators} from "../../services/Indicators.service";
import {toast} from "react-toastify";
import {Navigate, useLocation, useNavigate, useParams} from "react-router";
import {Tooltip} from 'components/Tooltip'
import {dellGoal, restoreGoal} from "../../services/Goals.service";
import {useUser} from "../../store/providers/app";
import Steps from "../Steps";
import {Button} from "react-bootstrap";
import {PreviewIndicator} from "../PreviewIndicator";

export const Buttons = ({trashed, id, title, isFetching, status}) => {

    const {param} = useParams()

    const {pathname} = useLocation()

    const navigate = useNavigate()

    const handleRestore = (id, title) => {

        swalQuestion(`${param === 'goals'
            ? i18n.t('questions.restoreGoal')
            : i18n.t('questions.restoreIndicator')
        } <b> ${title} </b> ?`)
            .then((result) => {
                if (result.isConfirmed) {

                    if (param === 'goals') {
                        restoreGoal(id).then(response => {
                            if (response.success) {

                                toast.success(i18n.t('success.successRestoreGoal'))

                                navigate(`/redirect${pathname}${id && '/' + id}`)
                            }
                        }).catch(() => swalBadRequest())

                    } else {
                        restoreIndicators(id).then(response => {
                            if (response.success) {

                                toast.success(i18n.t('success.successRestore'))

                                navigate(`/redirect${pathname}${id && '/' + id}`)
                            }
                        }).catch(() => swalBadRequest())
                    }
                }
            })
    }

    const handleDelete = (id, title, forceDelete) => {
        swalQuestion(`${forceDelete ? i18n.t('questions.deleteGoal') : i18n.t('questions.occultGoal')} <b> ${title} </b> ?`)
            .then((result) => {
                if (result.isConfirmed) {
                    dellGoal(id, forceDelete).then(response => {

                        if (response.success) {

                            toast.success(i18n.t('success.successOccultGoal'))

                            navigate(`/redirect${pathname}${id && '/' + id}`)
                        }
                    }).catch(() => toast.error(i18n.t('error.badRequest')))
                }
            })
    }

    return (
        <div className="d-flex float-end gap-2">
            {!trashed ?
                <>
                    <Tooltip label={i18n.t('label.occultGoal')}>
                        <button
                            className={`btn btn-outline-danger btn-sm bi-eye-slash ${isFetching && "disabled"}`}
                            onClick={() => handleDelete(id, title)}
                        />
                    </Tooltip>

                    <Tooltip label={i18n.t('label.editGoal')}>
                        <Link
                            to={`/workflow/goals/${id}`}
                            className={`btn btn-outline-primary btn-sm bi-pencil ${isFetching && "disabled"}`}
                        />
                    </Tooltip>

                    <Steps
                        onlyIcon={true}
                        param="goal"
                        idDb={id}
                    />
                 </>
                :

                <>
                    <Tooltip label={i18n.t('label.restoreGoal')}>
                        <button
                            className={`btn btn-outline-success btn-sm bi-arrow-clockwise ${isFetching && "disabled"}`}
                            onClick={() => handleRestore(id, title)}/>
                    </Tooltip>

                    <Tooltip label={i18n.t('label.deletePermanent')}>
                        <button
                            className={`btn btn-outline-danger btn-sm bi-trash ${isFetching && "disabled"}`}
                            onClick={() => handleDelete(id, title, true)}/>
                    </Tooltip>
                </>
            }
        </div>
    )
}

export const ButtonsTable = ({trashed, id, title, isFetching, status, code}) => {

    const {param} = useParams()
    const {pathname} = useLocation()
    const navigate = useNavigate()
    const {user} = useUser()

    const handleRestore = (id, title) => {

        swalQuestion(`${param === 'goals'
            ? i18n.t('questions.restoreGoal')
            : i18n.t('questions.restoreIndicator')
        } <b> ${title} </b> ?`)
            .then((result) => {
                if (result.isConfirmed) {

                    if (param === 'goals') {
                        restoreGoal(id).then(response => {
                            if (response.success) {

                                toast.success(i18n.t('success.successRestoreGoal'))

                                navigate(`/redirect${pathname}${id && '/' + id}`)
                            }
                        }).catch(() => swalBadRequest())

                    } else {
                        restoreIndicators(id).then(response => {
                            if (response.success) {

                                toast.success(i18n.t('success.successRestore'))

                                navigate(`/redirect${pathname}${id && '/' + id}`)
                            }
                        }).catch(() => swalBadRequest())
                    }
                }
            })
    }

    const handleDelete = (id, title, forceDelete) => {
        swalQuestion(`${param === 'goals'
            ? forceDelete ? i18n.t('questions.deleteGoal') : i18n.t('questions.occultGoal')
            : forceDelete ? i18n.t('questions.deleteIndicator') : i18n.t('questions.occultIndicator')
        } <b> ${title} </b> ?`)
            .then((result) => {
                if (result.isConfirmed) {

                    if (param === 'goals') {
                        dellGoal(id, forceDelete).then(response => {
                            if (response.success) {
                                toast.success(i18n.t('success.successOccultGoal'))
                                navigate(`/redirect${pathname}${id && '/' + id}`)
                            }
                        }).catch(() => toast.error(i18n.t('error.badRequest')))
                    } else {
                        dellIndicators(id, forceDelete).then(response => {
                            if (response.success) {

                                toast.success(i18n.t('success.successOccult'))
                                navigate(`/redirect${pathname}${id && '/' + id}`)
                            }
                        }).catch(() => toast.error(i18n.t('error.badRequest')))
                    }
                }
            })
    }

    const ButtonEdit = ({id, isFetching}) => {
        return (
            <Tooltip label={i18n.t('label.editIndicator')}>
                <Link
                    to={`/collect/indicator/edit/${id}`}
                    className={`btn btn-outline-primary btn-sm bi-pencil ${isFetching && "disabled"}`}
                />
            </Tooltip>
        )
    }

    const ButtonTranslate = ({id, isFetching}) => {
        return (
            <Tooltip label="Traduzir indicador">
                <Link
                    to={`/collect/translate/${code}`}
                    className={`btn btn-outline-primary btn-sm bi-translate ${isFetching && "disabled"}`}
                />
            </Tooltip>
        )
    }

    const ButtonSee = ({id, isFetching}) => {
        return (
            <Tooltip label="Ver indicador">
                <Link
                    to={`/collect/indicator/edit/${id}`}
                    className={`btn btn-outline-primary btn-sm bi-eye ${isFetching && "disabled"}`}
                />
            </Tooltip>
        )
    }

    const ButtonOcult = ({id, isFetching}) => {
        return (
            <Tooltip label={i18n.t('label.occultIndicator')}>
                <button
                    className={`btn btn-outline-danger btn-sm bi-eye-slash ${isFetching && "disabled"}`}
                    onClick={() => handleDelete(id, title)}
                />
            </Tooltip>
        )
    }

    return (
        <div className="d-flex float-end gap-1">
            {!trashed ?
                <>
                    { user.profile === 1 && status === 'draft_en' &&
                        <>
                            <ButtonTranslate id={id} isFetching={isFetching} />
                        </>
                    }

                    { user.profile === 1 &&
                        <>
                            <ButtonOcult id={id} isFetching={isFetching}/>
                            <ButtonEdit id={id} isFetching={isFetching}/>
                            {/*<Steps idDb={id} onlyIcon={true} statusIndicator={status}/>*/}
                        </>
                    }

                    { user.profile === 2  &&
                        <>
                            <ButtonEdit id={id} isFetching={isFetching} />

                        </>
                    }

                    { user.profile === 3 && status === 'draft' &&
                        <>
                            <ButtonEdit id={id} isFetching={isFetching} />
                            {/*<Steps idDb={id} onlyIcon={true} statusIndicator={status}/>*/}
                        </>
                    }

                    { user.profile === 4 && status === 'evaluation_avesso' &&
                        <>
                            <ButtonEdit id={id} isFetching={isFetching} />
                            {/*<Steps idDb={id} onlyIcon={true} statusIndicator={status}/>*/}
                        </>
                    }

                    { user.profile === 5 && status === 'evaluation_suzano' ?
                        <>
                            <ButtonEdit id={id} isFetching={isFetching} />
                            {/*<Steps idDb={id} onlyIcon={true} statusIndicator={status}/>*/}
                        </>
                        : user.profile === 5 && status === 'evaluation_suzano_en' &&
                            <>
                                <ButtonEdit id={id} isFetching={isFetching} />
                                {/*<Steps idDb={id} onlyIcon={true} statusIndicator={status}/>*/}
                            </>
                    }

                    { user.profile === 6 && status === 'draft_en' &&
                        <>
                            <ButtonTranslate id={id} isFetching={isFetching} />
                            {/*<Steps idDb={id} onlyIcon={true} statusIndicator={status}/>*/}
                        </>
                    }


                    { user.profile === 7 && status === 'finished' &&
                        <ButtonSee id={id} isFetching={isFetching} />
                    }

                    <PreviewIndicator indicatorId={id}  />
                    <Steps
                        idDb={id}
                        onlyIcon={true}
                        statusIndicator={status}
                    />

                </>
                :
                <>
                    <Tooltip label={param === 'goals' ? i18n.t('label.restoreGoal') : i18n.t('label.restoreIndicator')}>
                        <button
                            className={`btn btn-outline-success btn-sm bi-arrow-clockwise ${isFetching && "disabled"}`}
                            onClick={() => handleRestore(id, title)}/>
                    </Tooltip>

                    <Tooltip label={i18n.t('label.deletePermanent')}>
                        <button
                            className={`btn btn-outline-danger btn-sm bi-trash ${isFetching && "disabled"}`}
                            onClick={() => handleDelete(id, title, true)}/>
                    </Tooltip>
                </>
            }
        </div>
    )
}
